import React from "react";
import { AppInfo, ConnectionData } from "../types";
import AppCard from "./AppCard";
import AnimatedLogoCloud from "./LogoCloud";

interface InstalledAppsProps {
  installedApps: ConnectionData[];
  getAppInfoForConnection: (connection: ConnectionData) => AppInfo | null;
  setActiveTab: (tab: "browse" | "installed") => void;
  refetchConnections: () => Promise<void>;
}

const InstalledApps: React.FC<InstalledAppsProps> = ({
  installedApps,
  getAppInfoForConnection,
  setActiveTab,
  refetchConnections,
}) => {
  return (
    <div className="p-4 border-t border-secondary">
      {installedApps.length > 0 ? (
        installedApps.map((connection, index) => {
          const appInfo = getAppInfoForConnection(connection);
          if (!appInfo) return null;

          return (
            <AppCard
              key={index}
              icon={
                appInfo.image ? (
                  <img
                    src={appInfo.image}
                    alt={appInfo.name}
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-800 flex items-center justify-center">
                    {appInfo.name.charAt(0)}
                  </div>
                )
              }
              name={appInfo.name}
              description={
                appInfo.description || `Connected ${connection.platform} app`
              }
              isInstalled={true}
              connectionId={connection?._id}
              refetchConnections={refetchConnections}
            />
          );
        })
      ) : (
        <div className="flex flex-col h-full w-full justify-center items-center mt-[10rem]">
          <AnimatedLogoCloud />
          <div className="flex flex-col gap-2 justify-center items-center w-full">
            <p className="text-sm">You haven't installed any apps.</p>
            <div
              className="hover:bg-[#1F1F22] hover:cursor-pointer text-sm bg-transparent border w-full mt-1 py-1 px-3 rounded-lg flex flex-col items-center transition-all duration-200 ease-in-out"
              onClick={() => setActiveTab("browse")}
            >
              Browse
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(InstalledApps);
